import { Controller, Control, FieldValues } from 'react-hook-form';
import { FormControlLabel, Switch, Box } from '@mui/material';

import { useLocalization } from 'localization';

interface SwitchProps<T extends FieldValues = FieldValues> {
  name: string;
  control: Control<T>;
  label: string;
  disabled?: boolean;
  onChange?: (value: boolean) => void;
  labelPlacement?: 'start' | 'end' | 'top' | 'bottom';
}

export const SwitchField = <T extends FieldValues = FieldValues>(props: SwitchProps<T>) => {
  const { t } = useLocalization();
  const { name, control, label, disabled, onChange, labelPlacement = 'start' } = props;
  return (
    <Box>
      <Controller
        name={name as any}
        control={control}
        render={({ field: { value, onChange: fieldOnChange, onBlur }, fieldState: { error } }) => (
          <FormControlLabel
            control={
              <Switch
                checked={value}
                onChange={event => {
                  const isChecked = event.target.checked;
                  fieldOnChange(isChecked);
                  onChange?.(isChecked);
                }}
                onBlur={onBlur}
                disabled={disabled}
              />
            }
            label={t(label)}
            labelPlacement={labelPlacement}
            sx={{
              '&.MuiFormControlLabel-labelPlacementStart': {
                margin: 0,
                '& .MuiFormControlLabel-label': { marginRight: 2 },
              },
              '&.MuiFormControlLabel-labelPlacementEnd ': {
                margin: 0,
                '& .MuiFormControlLabel-label': { marginLeft: 2 },
              },
              '&.MuiSwitch-sizeMedium': {
                width: '2.225rem',
              },
              '& .MuiSwitch-root': { width: '2.275rem !important' },
            }}
          />
        )}
      />
    </Box>
  );
};
